import request from '@/utils/request'
// import qs from 'qs'

// 轮播图列表
export const bannerList = (getData) => {
  return request({
    url: '/web/banner/pageSizeList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 轮播图单个详情
export const getId = (getData) => {
  return request({
    url: '/web/banner/getId',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除
export const deleteBanner = (getData) => {
  return request({
    url: '/web/banner/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改
export const updateBanner = (postData) => {
  return request({
    url: '/web/banner/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增
export const addBanner = (postData) => {
  return request({
    url: '/web/banner/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
